import React from "react";
import { Pagination as BPagination } from "react-bootstrap";
import { usePagination } from "hooks";
import { Icons } from "components";

export default function Pagination({ count, perPage }) {
  const { page, handleSetPage, onPrev, onNext } = usePagination();
  const [siblingCount] = React.useState(2);
  const [totalCount] = React.useState(Math.ceil(count / perPage));

  const calculateRange = (start, end) => {
    let length = end - start + 1;
    /* Create an array of certain length and set the elements within it from
          start value to end value.
      */
    return Array.from({ length }, (_, idx) => idx + start);
  };

  const range = React.useMemo(() => {
    // Pages count is determined as siblingCount + firstPage + lastPage + currentPage
    const totalPageNumbers = siblingCount + 3;

    /*
        Case 1:
        If the number of pages is less than the page numbers we want to show in our
        paginationComponent, we return the range [1..totalCount]
      */
    if (totalPageNumbers >= totalCount) {
      return calculateRange(1, totalCount);
    }

    /*
        Calculate left and right sibling index and make sure they are within range 1 and totalCount
      */
    const leftSiblingIndex = Math.max(page - siblingCount, 1);
    const rightSiblingIndex = Math.min(page + siblingCount, totalCount);

    const firstPageIndex = 1;
    const lastPageIndex = totalCount;

    let middleRange = calculateRange(leftSiblingIndex, rightSiblingIndex);

    if (page - siblingCount <= firstPageIndex)
      return [...middleRange, lastPageIndex];
    else if (page + siblingCount >= totalCount)
      return [firstPageIndex, ...middleRange];
    return [firstPageIndex, ...middleRange, lastPageIndex];
  }, [totalCount, siblingCount, page]);

  if (page === 0 || range.length < 2) {
    return null;
  }

  return (
    <>
      {totalCount !== 1 && (
        <BPagination>
          {page > 1 && (
            <BPagination.Item onClick={onPrev} className="arrowLink">
              <Icons.VectorLeft className="reversed" />
            </BPagination.Item>
          )}
          {range.map((pageNumber) => (
            <BPagination.Item
              key={pageNumber}
              active={pageNumber === page}
              onClick={() => handleSetPage(pageNumber)}
            >
              <div>{pageNumber}</div>
            </BPagination.Item>
          ))}
          {page < totalCount && (
            <BPagination.Item onClick={onNext} className="arrowLink">
              <Icons.VectorLeft />
            </BPagination.Item>
          )}
        </BPagination>
      )}
    </>
  );
}
